<ng-container *ngIf="inviseoVariablesExtraction;else noData">
  <div class="card-header">
    <div class="grid-x">
      <div class="cell auto">
        <h4 appEllipsisWithTooltip [id]="'WIDGET_'.concat(widget.size)">{{"widget.name.".concat(widget.widgetName) | translate}}</h4>
      </div>
      <div *ngIf="widget.size === WidgetSize.LARGE && inviseoVariablesExtraction.variableValues.length > 1"
           class="cell shrink">
      <span *ngFor="let variableValues of inviseoVariablesExtraction.variableValues; let i = index"
            class="f-10 c-medium-gray padding-r-xs">
        <span class="fas fa-circle" [style]="getLegendStyle(i)"></span>
        {{ 'widget.inviseo-variables.series.name.' + variableValues.variableCode | translate}}
      </span>
      </div>
  </div>
</div>

<div class="card-body">
  <div class="d-block margin-b-xs margin-l">
    <span class="c-medium-gray i-block" style="font-weight: 500;">
      {{inviseoVariablesExtraction.context.scenarioName}}
    </span>
  </div>
  <div [chart]="chart" class="d-block margin-r" style="height: 85%;width:99%;"></div>
</div>

  <div class="card-footer">
    <a (click)="actionEvent.emit('widget.inviseo-variables.link-label.' + widget.widgetName)" [href]="getRedirectLink()"
       class="button insito">
      <span
        [title]="'widget.inviseo-variables.link-label.' + widget.widgetName | translate">{{ 'widget.inviseo-variables.link-label.' + widget.widgetName | translate}}</span>
    </a>
  </div>
</ng-container>
<ng-template #noData>
  <app-widget-message [message]="'widget.inviseo-variables.no-scenario'| translate"
                      [widgetLabel]="'widget.name.'.concat(widget.widgetName) | translate"
                      [widgetSize]="widget.size"
                      icone="opt-stat"></app-widget-message>
</ng-template>
